import { memo } from 'react';

import SelectedText from '../../SelectedText';

const Text = ({ message }) => {
  return <SelectedText {...message.textChunk} />;
};

export default memo(Text);
